import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { COMPANIA_MAIN, COMPANIA_NUEVO } from 'constants/codigosTransacciones'

import FichaPage from './ficha'
import NuevoPage from './nuevo'

export default function CompaniaPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${COMPANIA_MAIN}`} component={FichaPage} />
        <Route path={`/${COMPANIA_NUEVO}`} component={NuevoPage} />
      </Switch>
    </Suspense>
  )
}
